/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/admin/controleacesso/usuarios`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/admin/controleacesso/usuarios/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorIdComPerfisAcesso(usuarioId) {
        return axiosJwt.get(`${api}/admin/controleacesso/usuarios/${usuarioId}/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirUsuario(usuario) {
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarUsuario(usuario) {
        return axiosJwt.put(`${api}/admin/controleacesso/usuarios`, usuario)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfilAcesso(usuarioPerfilAcesso) {
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfilAcesso(usuarioPerfilAcesso) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioPerfilAcesso.usuarioId}/perfilacesso`, usuarioPerfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarPerfisAcesso(usuarioPerfisAcesso) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioPerfisAcesso.usuarioId}/perfisacesso`, usuarioPerfisAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarCredores(usuarioCredores) {
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios/${usuarioCredores.usuarioId}/credores`, usuarioCredores)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarCredor(usuarioCredor) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioCredor.usuarioId}/credor`, usuarioCredor)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarCredores(usuarioCredores) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioCredores.usuarioId}/credores`, usuarioCredores)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    ativarDesativarUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioId}/ativardesativar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    resetarSenhaUsuario(usuarioId) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioId}/resetarsenha`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    trocarSenhaUsuario(usuarioId, trocaSenha) {
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioId}/trocarsenha`, trocaSenha)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    pesquisarLoginAd(login) {
        return axiosJwt.get(`${api}/admin/controleacesso/usuarios/ad/${login}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterContratos(){
        return axiosJwt.get(`${api}/admin/controleacesso/usuarios/contratos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarContrato(usuarioContrato){
        return axiosJwt.post(`${api}/admin/controleacesso/usuarios/${usuarioContrato.usuarioId}/contratos`, usuarioContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
    
    desassociarContrato(usuarioContrato){
        return axiosJwt.patch(`${api}/admin/controleacesso/usuarios/${usuarioContrato.usuarioId}/contratos`, usuarioContrato)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }
}
